import React from "react";
import "./WalletCard.css";
import { useNavigate } from "react-router-dom";
import { faArrowRightArrowLeft, faWallet } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function WalletCard() {
    const navigate = useNavigate();
  return (
    <div className="wallet_card">
      <h3>₹104.00 <FontAwesomeIcon icon={faArrowRightArrowLeft} className="ms-1"  style={{color:"#6D6D6D"}}/> </h3>
      <p><FontAwesomeIcon icon={faWallet} className="me-1" style={{color:"#F43A54"}}/>  Wallet Balance</p>

      <div className="wallet_buttons">
        <button className="withdraw_btn withdraw_btn_holder" onClick={() => navigate("/withdraw")}>Withdraw</button>
        <button className="deposit_btn withdraw_btn_holder" onClick={() => navigate("/deposite")}>Deposit</button>
      </div>
    </div>
  );
}

export default WalletCard;